<template>
  <TeaserAccountTile>
    <template v-slot:component>
      <CustomerActivationForm></CustomerActivationForm>
    </template>
  </TeaserAccountTile>
</template>

<script setup lang="ts">
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
import CustomerActivationForm from '@/componentsTenant/account-management/CustomerActivationForm.vue'
</script>
